<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="secondary" v-b-tooltip.hover :title="showToolTip ? 'Печать' : ''"><i class="fa fa-print"></i></b-button>
</template>

<script>

export default ({
  name: "button-print",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
